var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.sideBarStatus ? 'md:pr-80' : 'md:pr-16', 'duration-500 min-h-screen bg-surface'],attrs:{"id":"layoutPage"}},[_c('sidebar'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }